<script setup lang="ts">
  import SiteHeader from '@/components/SiteHeader.vue'
  import SiteFooter from '@/components/SiteFooter.vue'
</script>

<template>
  <div class="app-wrapper">
    <!-- Floating Logo with negative effect -->
    <div class="floating-logo-container">
      <router-link :to="{ name: 'Home' }">
        <svg
          class="floating-logo"
          width="94"
          height="73"
          viewBox="0 0 94 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              class="logo-path"
              fill="#ffffff"
              d="M62.0974 69.0877L59.4028 69.0911L59.6332 42.6816L81.4442 3.9056L85.341 3.93892L85.3376 14.3461L88.453 14.3694V3.96558V0.0233269H85.4278L66.7956 0.00999726L66.7655 3.77563L76.9531 3.86561L57.977 38.2828L49.1751 22.4872L58.3009 0.0166621L49.4088 0.00666484H19.2633L19.2299 3.83228H26.4591L39.2846 26.2261L28.7431 53.0455L8.89539 0.00999726L0 0L28.5794 72.9967L44.1096 34.6538L48.6542 42.5883L48.4204 69.0911H40.7305L40.7038 72.9967L67.0493 73H69.921H77.7812H77.9615H79.3673H85.2141H88.4564V69.3277V69.2943V33.0699L94 39.6656L86.9278 15.189L79.8155 39.6923L85.341 33.1345V69.0911H80.9534L62.0974 69.0877ZM38.6068 3.52903L48.17 3.61234L44.2365 13.6296L38.6068 3.52903ZM68.3871 50.5703L59.8991 55.8422L69.8864 55.389L72.2872 65.0763L74.9451 55.4556L84.9157 56.1721L76.5679 50.6769L80.3311 41.4328L72.5176 47.6577L64.871 41.2295L68.3871 50.5703Z"
            />
          </g>
        </svg>
      </router-link>
    </div>

    <SiteHeader />

    <main class="main-content">
      <RouterView />
    </main>

    <SiteFooter />
  </div>
</template>

<style>
  :root {
    --header-height: 100px;
    --content-padding: 24px;
  }

  * {
    box-sizing: border-box;
  }

  html,
  body,
  #app {
    height: 100%;
  }

  body {
    margin: 0;
    background: #fff; /* allow strong contrast under the logo */
  }

  .app-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .main-content {
    flex: 1 0 auto;
    position: relative;
    width: 100%;
    z-index: 0;
    padding-left: var(--content-padding);
    padding-right: var(--content-padding);
  }

  .floating-logo-container {
    position: fixed;
    top: 30px;
    left: 24px;
    z-index: 2000; /* Higher than header to be on top */
    pointer-events: auto; /* Allow clicking */
    mix-blend-mode: difference; /* Apply blend mode to container */
  }

  .floating-logo {
    fill: #ffffff; /* White fill for maximum contrast in difference mode */
    width: 94px;
    height: 73px;
    transition: all 0.3s ease;
    display: block; /* Ensure proper rendering */
  }

  .floating-logo .logo-path {
    fill: #ffffff; /* Ensure the path has white fill */
    mix-blend-mode: difference; /* Apply blend mode to the path itself */
  }

  .floating-logo:hover {
    transform: scale(1.05);
  }

  /* Handy utility for the first section on any page (see HomeView.vue) */
  .page-first-section {
    padding-top: calc(var(--header-height) + 24px);
  }

  @media (max-width: 768px) {
    :root {
      --content-padding: 16px;
      --header-height: 60px;
    }

    .floating-logo-container {
      display: none;
    }

    .main-content {
      padding-left: var(--content-padding);
      padding-right: var(--content-padding);
    }
  }
</style>
